import React from 'react';
import ServiceListItem from '../ServiceListItem';
import JsxHelper from '../../Helpers/JsxHelper';
import LookupTextLookupItemIdArray from '../../Elements/LookupTextLookupItemIdArray';
import TabListTableCellWidthEnum from '../../Enums/TabListTableCellWidthEnum';
import LookupText from '../../Elements/LookupTextArray';

export default class BusinessIntelligenceServiceItem extends ServiceListItem {
  static FieldsToShowInListTable = [
    ...ServiceListItem.generalTab,
    {
      tabName: 'Fieldwork',
      tabLabel: 'Fieldwork',
      icon: 'fa-solid fa-briefcase',
      data: [
        { name: (item) => <LookupText lookupId={37} value={item.MaxDeliveryAfterShop} />, label: 'Time to Deliver Evaluation to Client' },
      ],
    },
    {
      tabName: 'Dashboard',
      tabLabel: 'Dashboard',
      icon: 'fa-solid fa-file-lines',
      data: [
        { name: (item) => Array.isArray(item.ReportingRequirements) ? item.ReportingRequirements.join(', ') : (item.ReportingRequirements || ''), label: 'Analysis Features' },
        { name: 'DetailedReportingRequirements', label: 'Analysis Features (Other)', width: TabListTableCellWidthEnum.TwoLines },
        { name: 'BitoolSelection', label: 'BI Tool Selection' },
        { name: 'FrequencyOfUpdate', label: 'Frequency of Update' },
        { name: 'DataSourcesOtherThanMs', label: 'Data Sources Other Than MS' },
        { name: (item) => Array.isArray(item.BiMainMetrics) ? item.BiMainMetrics.join(', ') : (item.BiMainMetrics || ''), label: 'Main metrics' },
        { name: (item) => Array.isArray(item.Comparison) ? item.Comparison.join(', ') : (item.Comparison || ''), label: 'Comparison' },
        { name: 'ComparisonDescription', label: 'Please Describe', width: TabListTableCellWidthEnum.TwoLines },
        { name: (item) => Array.isArray(item.AdditionalVisualizations) ? item.AdditionalVisualizations.join(', ') : (item.AdditionalVisualizations || ''), label: 'Additional Visualizations' },
        { name: 'InsightHighlights', label: 'Insight Highlights' },
        { name: (item) => Array.isArray(item.InteractiveFeatures) ? item.InteractiveFeatures.join(', ') : (item.InteractiveFeatures || ''), label: 'Interactive Features' },
        { name: 'SubDashboards', label: 'Sub Dashboards' },
        { name: 'SubDashboardsDescription', label: 'If yes describe Sub Dashboards', width: TabListTableCellWidthEnum.TwoLines },
        { name: 'Mspplatform', label: 'MSP Platform' },
      ],
    },
    {
      tabName: 'Presentation',
      tabLabel: 'Presentation',
      icon: 'fa-solid fa-chart-bar',
      data: [
        { name: 'Template', label: 'Template' },
        { name: 'Output', label: 'Output' },
        { name: 'BiNumVisualizations', label: 'Number of Visualizations (slides)' },
        { name: 'Kpianalysis', label: 'KPI Analysis' },
        { name: (item) => JsxHelper.YesNo(item.BenchmarkingAgainstIndustry), label: 'Benchmarking Against Industry' },
        { name: 'SourcesTypeOfPrograms', label: 'Sources / Type of Programs' },
        { name: 'NumOpenEndsAnalyzed', label: 'Number of Open Ends to Be Analyzed' },
        { name: 'NumEvalPerCycle', label: 'Number of Evaluations per Cycle' },
      ],
    },
    {
      tabName: 'BI Analysis',
      tabLabel: 'BI Analysis',
      icon: 'fa-solid fa-comment-dots',
      data: [
        { name: (item) => JsxHelper.YesNo(item.TextAnalyticsVerbatimNonEnglish), label: 'Verbatim non-English?' },
        { name: 'TextAnalyticsVerbatimDescription', label: 'If yes describe', width: TabListTableCellWidthEnum.TwoLines },
        { name: 'TextAnalyticsOutputsNonEnglish', label: 'Outputs non-English?' },
        { name: (item) => Array.isArray(item.ServicesNeed) ? item.ServicesNeed.join(', ') : (item.ServicesNeed || ''), label: 'Services Need' },
      ],
    },
    {
      tabName: 'Consultancy',
      tabLabel: 'Consultancy',
      icon: 'fa-solid fa-font',
      data: [
        { name: 'BiconsultancyDescription', label: 'Please describe what consulting is needed', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
    {
      tabName: 'Questionnaire',
      tabLabel: 'Questionnaire',
      icon: 'fa-solid fa-clipboard-question',
      data: [
        { name: 'NumClosedQuestions', label: 'No. Closed Questions' },
        { name: 'NumOpenQuestions', label: 'No. Short Answer Questions' },
        { name: 'NumNarrativeQuestions', label: 'No. Narrative Questions' },
        { name: (item) => <LookupTextLookupItemIdArray lookupId={20} valueArray={item.RequiredLanguageCode} />, label: 'Required Language(s) Reporting' },
        { name: 'Regularity', label: 'Regularity' },
        { name: 'SpecificRequirements', label: 'Please Enter Specific Requirements' },
        { name: 'TopIssues', label: 'Top Issues' },
      ],
    },
    ...ServiceListItem.commonEndTabs,
  ];
}
